import { AppContext } from '../../context';
import { Button } from '@goodtimeio/rain';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { useContext } from 'react';
import Wrapper from '../../components/Wrapper';

import './styles.scss';

const TimeAlreadyBooked = () => {
    const { meetIntro, translate, addTimeSlot, addDays } = useContext(AppContext);
    const { hash } = useParams<{ hash: string }>();
    const history = useHistory();
    if (!meetIntro) {
        return <Redirect to={`/intro/${hash}`} />;
    }
    const onUpdateAvailability = () => {
        addTimeSlot('');
        addDays([]);
        return history.push(`/pickDays/${hash}`);
    };
    const BACKGROUND_STYLES = {
        backgroundImage: `url("${meetIntro?.data?.meetBackgroundUrl}")`,
    };
    const logo = meetIntro?.data?.organization?.logoUrl;
    const backgroundImage = meetIntro?.data?.meetBackgroundUrlList[2] ?? meetIntro?.data?.meetBackgroundUrlList[0];
    return (
        <Wrapper loading={meetIntro?.isLoading} backgroundImage={backgroundImage} logo={logo}>
            <div className="cardContainer" style={BACKGROUND_STYLES}>
                <div className="cardContent">
                    <h1 className="title">{translate('apiError:unavailableTime')}</h1>
                    <p className="confirmationMsg">{translate('apiError:timeAlreadyBooked')}</p>
                </div>
                <div className="cardFooter">
                    <Button className="rescheduleButton" onClick={onUpdateAvailability}>
                        {translate('confirm:updateAvailability')}
                    </Button>
                </div>
            </div>
        </Wrapper>
    );
};

export default TimeAlreadyBooked;
